module.exports = __webpack_public_path__ + "static/media/step6.df66ec1a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/quest_box/animation/step6.svg
// module id = 1244
// module chunks = 0